import React, { useState } from 'react';
import AiTextDialog from './AiTextDialog';
import { aiAPI } from '../../services/api';

interface AiPlayerEvaluationDialogProps {
  playerId: number;
  playerName: string;
  isOpen: boolean;
  onClose: () => void;
}

const inputClass =
  'mt-1 w-full rounded-md border border-gray-300 px-3 py-2 text-base sm:text-sm focus:outline-none focus:ring-2 focus:ring-primary-500';

const toDateInput = (date: Date) => date.toISOString().split('T')[0];

/** Fejlődési értékelés vázlata a szülőknek vagy a stábnak, a statisztikákból és az edző megfigyeléseiből. */
const AiPlayerEvaluationDialog: React.FC<AiPlayerEvaluationDialogProps> = ({ playerId, playerName, isOpen, onClose }) => {
  const [audience, setAudience] = useState<'parents' | 'internal'>('parents');
  const [dateFrom, setDateFrom] = useState(() => {
    const d = new Date();
    d.setMonth(d.getMonth() - 6);
    return toDateInput(d);
  });
  const [dateTo, setDateTo] = useState(() => toDateInput(new Date()));
  const [coachNotes, setCoachNotes] = useState('');

  return (
    <AiTextDialog
      isOpen={isOpen}
      onClose={onClose}
      title={`Értékelés: ${playerName}`}
      intro="Az AI az edzéslátogatásból, a mérkőzésstatisztikából és a saját megfigyeléseidből vázlatot ír. A megfigyeléseid adják a szöveg lényegét - nélkülük csak a számokról tud írni."
      generate={async () =>
        (
          await aiAPI.playerEvaluation(playerId, {
            audience,
            dateFrom: dateFrom || null,
            dateTo: dateTo || null,
            coachNotes: coachNotes.trim() || null,
          })
        ).content
      }
    >
      <label className="block text-sm font-medium text-gray-700">
        Kinek szól?
        <select value={audience} onChange={(e) => setAudience(e.target.value as 'parents' | 'internal')} className={inputClass}>
          <option value="parents">A szülőknek</option>
          <option value="internal">Belső, a stábnak</option>
        </select>
      </label>
      <div className="grid grid-cols-2 gap-3">
        <label className="block text-sm font-medium text-gray-700">
          Időszak kezdete
          <input type="date" value={dateFrom} onChange={(e) => setDateFrom(e.target.value)} className={inputClass} />
        </label>
        <label className="block text-sm font-medium text-gray-700">
          Vége
          <input type="date" value={dateTo} onChange={(e) => setDateTo(e.target.value)} className={inputClass} />
        </label>
      </div>
      <label className="block text-sm font-medium text-gray-700">
        Megfigyeléseid
        <textarea
          rows={4}
          maxLength={2000}
          value={coachNotes}
          onChange={(e) => setCoachNotes(e.target.value)}
          placeholder="pl. jó a labdaátvétele, gyorsan dönt; gyenge lábbal még bizonytalan; sokat fejlődött a csapatjátékban"
          className={inputClass}
        />
      </label>
    </AiTextDialog>
  );
};

export default AiPlayerEvaluationDialog;
